import { get, put } from 'redux/shelf/api';
import { createReducer } from 'redux/shelf/reducer';
import session from 'lib/session';

export const actions = {
  getMultiMarket: get`settings/${session.getMerchant}/multi-market`(),
  updateMultiMarket: put`settings/${session.getMerchant}/multi-market`(),
};

export const reducer = createReducer(actions);
